var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['pins-item', {'pins-item--has-action': _vm.hasAction}],on:{"click":_vm.onAction_ClickHandler}},[_c('div',{staticClass:"pins-item__content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"pins-item__footer"},[_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cddc6b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pins/PinsItem.vue
// module id = null
// module chunks = 